export class MfsPreviewDialogResult {
  supplier: number;
  creditor: number;
  user: number;
  previewBy: string;
}
